import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  selectAsText: {
    pointerEvents: 'none',
    backgroundColor: 'transparent !important',
    '.ant-select-selector': {
      border: 'none !important',
      boxShadow: 'none !important',
      backgroundColor: 'transparent !important',
      paddingLeft: '0 !important',
      fontSize: '14px',
      '.ant-select-selection-item': {
        color: token.colorTextSecondary
      }
    },
    '.ant-select-arrow': {
      display: 'none !important'
    }
  }
}))
